export const overSpeedRuleListUrl = '/overSpeedRule/getRule'
export const overSpeedRuleAddUrl = '/overSpeedRule/createRule'
export const overSpeedRuleEditUrl = '/overSpeedRule/{0}'
export const overSpeedRuleDeleteUrl = '/overSpeedRule/{0}'
export const overSpeedRuleRuleCarUrl = '/overSpeedRule/ruleCarList/{0}'
export const overSpeedRuleNoRuleCarUrl = '/overSpeedRule/noRuleCarList'
export const overSpeedRuleAddCarUrl = '/overSpeedRule/{0}/addCar'
export const overSpeedRuleDeleteCarUrl = '/overSpeedRule/{0}/deleteCar'
